import { createApi } from "@reduxjs/toolkit/query/react";
import fetchBaseQueryCSRF from "../helper";

export interface ExportQueryParams {
    queryId: string;
    columns: string[];
    column_mapping?: Record<string, string>;
    column_tr: Record<string, string>;
    dimensions: string[];
    name: string;
}

const exportsAPI = createApi({
    baseQuery: fetchBaseQueryCSRF({
        baseUrl: process.env.CROSS_API_URL + '/exports',
    }),
    reducerPath: 'api.exports',
    tagTypes: ['exports'],
    endpoints: (builder) => ({
        export: builder.mutation<void, ExportQueryParams>({
            query: ({ queryId, column_tr, column_mapping, ...params }) => {
                const fparams = Object.entries(params).reduce((acc, [key, value]) => {
                    const fvalue = value ? (Array.isArray(value) ? value : [value]) : undefined;

                    if (!fvalue) {
                        return acc;
                    }

                    return acc + `&${key}=${fvalue.join(`&${key}=`)}`;
                }, "");

                return {
                    url: `/${queryId}?${fparams.slice(1, fparams.length)}`,
                    method: "POST",
                    body: {
                        column_tr,
                        column_mapping,
                    },
                }
            },
        }),
    }),
});

export const { useExportMutation } = exportsAPI;

export default exportsAPI;